module.exports = __webpack_public_path__ + "img/logo.48a3ce58.jpg";